import Vue from "vue";

export const jsonConfig = {
  url: '', // 网络请求URL
  method: 'get',// 请求方法，默认get
  baseURL: process.env.API_ROOT, // 基础URL路径，会自动添加到url前，除非url是绝对URL
  transformRequest: [
    function (data) {
      return data ? JSON.stringify(data) : data
    }
  ],// 允许在向服务器发送前，修改请求数据。适用PUT' || 'POST' || 'PATCH'
  transformResponse: [
    function (data) {
      return data ? JSON.parse(data) : data
    }
  ], // 在传递给 then/catch 前，允许修改响应数、
  headers: {
    // 'Authorization': Vue.$cookies.get('token') ? Vue.$cookies.get('token') : '',
    'Content-Type': 'application/json;charset=UTF-8',
  }, // 自定义请求头

  params: {},// 即将与请求一起发送的 URL 参数

  data: {},// 请求主体被发送的数据。适用于 'PUT' || 'POST' || 'PATCH'

  timeout: 80000,// 请求超时时间

  withCredentials: true,// 是否允许带cookie这些 // 表示跨域请求时是否需要使用凭证，默认false

  /*  onUploadProgress: function (progressEvent) {
    }, // 允许为上传处理进度事件

    onDownloadProgress: function (progressEvent) {
    }  // 允许为下载处理进度事件*/
}

export const formConfig = {
  url: '',// 网络请求URL

  method: 'post',// 请求方法，默认get

  baseURL: process.env.API_ROOT, // 基础URL路径，会自动添加到url前，除非url是绝对URL

  transformRequest: [
    function (data) {
      return data
    }
  ],// 允许在向服务器发送前，修改请求数据。适用PUT' || 'POST' || 'PATCH'

  transformResponse: [
    function (data) {
      return data ? JSON.parse(data) : data
    }
  ],// 在传递给 then/catch 前，允许修改响应数据

  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    isToken: false,
    Authorization: 'Basic Y2x0OmNsdA==',
  }, // 自定义请求头

  params: {},  // 即将与请求一起发送的 URL 参数

  data: {}, // 请求主体被发送的数据。适用于 'PUT' || 'POST' || 'PATCH'

  timeout: 80000,// 请求超时时间

  withCredentials: true,// 表示跨域请求时是否需要使用凭证，默认false

  onUploadProgress: function (progressEvent) {
  },// 允许为上传处理进度事件

  onDownloadProgress: function (progressEvent) {
  }// 允许为下载处理进度事件
}

export const blobConfig = {
  url: '',// 网络请求URL

  method: 'get',// 请求方法，默认get

  baseURL: process.env.API_ROOT, // 基础URL路径，会自动添加到url前，除非url是绝对URL
  // baseURL: comConfig.baseURL,// 基础URL路径，会自动添加到url前，除非url是绝对URL

  transformRequest: [
    function (data) {
      return data
    }
  ],// 允许在向服务器发送前，修改请求数据。适用PUT' || 'POST' || 'PATCH'

  transformResponse: [
    function (data) {
      return data ? data : data
    }
  ],// 在传递给 then/catch 前，允许修改响应数据

  headers: {
    'content-type': 'multipart/form-data',
    // 'Authorization': Vue.$cookies.get('token') ? Vue.$cookies.get('token') : '',
  }, // 自定义请求头

  params: {},  // 即将与请求一起发送的 URL 参数

  data: {}, // 请求主体被发送的数据。适用于 'PUT' || 'POST' || 'PATCH'

  timeout: 80000,// 请求超时时间

  withCredentials: true,// 表示跨域请求时是否需要使用凭证，默认false

  responseType: 'blob',

  onUploadProgress: function (progressEvent) {
  },// 允许为上传处理进度事件

  onDownloadProgress: function (progressEvent) {
  }// 允许为下载处理进度事件
}

export const fileConfig = {
  url: '',// 网络请求URL

  method: 'get',// 请求方法，默认get

  baseURL: process.env.API_ROOT, // 基础URL路径，会自动添加到url前，除非url是绝对URL
  // baseURL: comConfig.baseURL,// 基础URL路径，会自动添加到url前，除非url是绝对URL

  transformRequest: [
    function (data) {
      return data
    }
  ],// 允许在向服务器发送前，修改请求数据。适用PUT' || 'POST' || 'PATCH'

  transformResponse: [
    function (data) {
      return data ? data : data
    }
  ],// 在传递给 then/catch 前，允许修改响应数据

  headers: {
    'Content-Type': 'multipart/form-data',
    // 'Authorization': Vue.$cookies.get('token') ? Vue.$cookies.get('token') : '',
  }, // 自定义请求头

  params: {},  // 即将与请求一起发送的 URL 参数

  data: {}, // 请求主体被发送的数据。适用于 'PUT' || 'POST' || 'PATCH'

  timeout: 80000,// 请求超时时间

  withCredentials: true,// 表示跨域请求时是否需要使用凭证，默认false

  // responseType: 'blob',

  /*onUploadProgress: function (progressEvent) {
  },// 允许为上传处理进度事件

  onDownloadProgress: function (progressEvent) {
  }// 允许为下载处理进度事件*/
}



// WEBPACK FOOTER //
// ./src/utils/config.js